module.exports = __webpack_public_path__ + "img/w3_minimize_black.4e39ed08.png";